import React from "react";

export const IdFrontGizmo = ({
                                  stroke = '#ffffff',
                                  height= 175,
                                  width = 265,
                              }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 265 175" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1181 1H7.85826C4.09664 1 1.04724 4.0494 1.04724 7.81102V17.3465" stroke="black"
                  strokeWidth="1.3622"/>
            <path d="M20.1181 174H7.85826C4.09664 174 1.04724 170.951 1.04724 167.189V157.654" stroke="black"
                  strokeWidth="1.3622"/>
            <path d="M244.882 1H257.142C260.903 1 263.953 4.0494 263.953 7.81102V17.3465" stroke="black"
                  strokeWidth="1.3622"/>
            <path d="M244.882 174H257.142C260.903 174 263.953 170.951 263.953 167.189V157.654" stroke="black"
                  strokeWidth="1.3622"/>
            <rect x="7.85828" y="7.81104" width="249.283" height="158.016" rx="6.81102" fill="#E4EAFA"/>
            <rect x="118.197" y="36.4173" width="113.063" height="14.9843" rx="2.72441" fill="#ADC0F7"/>
            <rect x="118.197" y="56.8504" width="36.7795" height="5.44882" rx="2.72441" fill="#ADC0F7"/>
            <rect x="165.874" y="56.8504" width="65.3858" height="5.44882" rx="2.72441" fill="#ADC0F7"/>
            <rect x="119.559" y="69.1102" width="111.701" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="25.5669" y="99.0787" width="205.693" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="25.5669" y="111.339" width="205.693" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="25.5669" y="123.598" width="38.1417" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="75.9685" y="123.598" width="38.1417" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="126.37" y="123.598" width="38.1417" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="176.772" y="123.598" width="38.1417" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="129.094" y="135.858" width="102.165" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="25.5669" y="135.858" width="84.4567" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <path
                d="M52.811 79.5538C65.3497 79.5538 75.5144 69.3891 75.5144 56.8504C75.5144 44.3116 65.3497 34.147 52.811 34.147C40.2722 34.147 30.1075 44.3116 30.1075 56.8504C30.1075 69.3891 40.2722 79.5538 52.811 79.5538Z"
                stroke="#ADC0F7" strokeWidth="4.08661"/>
            <path
                d="M42.5945 68.2021C47.8882 62.6575 57.6768 62.3964 63.0276 68.2021H42.5945ZM58.4757 51.1746C58.4757 54.3092 55.9309 56.8504 52.7917 56.8504C49.6527 56.8504 47.1079 54.3092 47.1079 51.1746C47.1079 48.0399 49.6527 45.4987 52.7917 45.4987C55.9309 45.4987 58.4757 48.0399 58.4757 51.1746Z"
                fill="#ADC0F7"/>
            <path
                d="M42.5945 68.2021C47.8882 62.6575 57.6768 62.3964 63.0276 68.2021M58.4757 51.1746C58.4757 54.3092 55.9309 56.8504 52.7917 56.8504C49.6527 56.8504 47.1079 54.3092 47.1079 51.1746C47.1079 48.0399 49.6527 45.4987 52.7917 45.4987C55.9309 45.4987 58.4757 48.0399 58.4757 51.1746Z"
                stroke="#ADC0F7" strokeWidth="4.08661" strokeLinecap="round"/>
        </svg>
    );
};